const johannesburg = "Africa/Johannesburg";

/**
 * Format currency from cents, matching receipt-peek Afrikaans-style output.
 */
export function currency(amountCents: number): string {
    return new Intl.NumberFormat("af-ZA", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(amountCents / 100);
}

export function currencyLabel(amountCents: number): string {
    return `R${currency(amountCents)}`;
}

/** Whole-rand label for overview amounts where cents are not shown. */
export function currencyLabelWhole(amountCents: number): string {
    const whole = new Intl.NumberFormat("af-ZA", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(Math.round(amountCents / 100));
    return `R${whole}`;
}

export function unit(u: string): string {
    if (u?.toLowerCase() === "kl") {
        return "kℓ";
    }
    return u || "";
}

export function shortDate(date: string | Date): string {
    const d = typeof date === "string" ? new Date(date) : date;
    return new Intl.DateTimeFormat("en-ZA", {
        timeZone: johannesburg,
        day: "2-digit",
        month: "short",
        year: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    }).format(d).replace(",", "");
}

export function collectionDueDate(date: string | Date): string {
    const d = typeof date === "string" ? new Date(date) : date;
    return new Intl.DateTimeFormat("en-ZA", {
        timeZone: johannesburg,
        day: "2-digit",
        month: "short",
    }).format(d);
}

export function prettyDate(date: string | Date): string {
    const d = typeof date === "string" ? new Date(date) : date;
    return new Intl.DateTimeFormat("en-ZA", {
        timeZone: johannesburg,
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    }).format(d).replace(",", "");
}

export function hasUnits(units: string): boolean {
    const value = parseFloat(units);
    return !Number.isNaN(value) && value > 0;
}

export function totalCollectionFees(collections: { feesPaid: number; feesTaxPaid: number }[]): number {
    return collections.reduce((acc, collection) => acc + collection.feesPaid + collection.feesTaxPaid, 0);
}

export function totalCollectionsExcl(collections: { amountPaid: number }[]): number {
    return collections.reduce((acc, collection) => acc + collection.amountPaid, 0);
}

export function totalFeesIncl(
    productFeeCost: number,
    productFeeTax: number,
    collections: { feesPaid: number; feesTaxPaid: number }[]
): number {
    return productFeeCost + productFeeTax + totalCollectionFees(collections);
}
